module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('empty_list.no_data_available')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('empty_list.filter_case')) + " "), _c('span', {
    staticClass: "ls-cursor-pointer clear-filter-link",
    on: {
      "click": function($event) {
        _vm.$parent.$emit('clearFilters')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('empty_list.clear_filter')))]), _vm._v(" " + _vm._s(_vm.$t('empty_list.back_to_default_list')))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e8ebdfd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/shareds/empty-list/EmptyList.vue
// module id = 773
// module chunks = 1